module.exports = __webpack_public_path__ + "static/media/bot-bg-mobile.934916a1.png";